export type SoftwareNotice = { name: string; license: string; source: string };

export const SOFTWARE_NOTICES: readonly SoftwareNotice[] = [
  { name: 'Fredoka', license: 'SIL Open Font License 1.1', source: 'https://fonts.google.com/specimen/Fredoka' },
  { name: 'Nunito', license: 'SIL Open Font License 1.1', source: 'https://fonts.google.com/specimen/Nunito' },
  { name: 'React', license: 'MIT', source: 'https://github.com/facebook/react' },
  { name: 'React Router', license: 'MIT', source: 'https://github.com/remix-run/react-router' },
  { name: 'TanStack Query', license: 'MIT', source: 'https://github.com/TanStack/query' },
  { name: 'Zustand', license: 'MIT', source: 'https://github.com/pmndrs/zustand' },
  { name: 'Better Auth', license: 'MIT', source: 'https://github.com/better-auth/better-auth' },
  { name: 'Colyseus SDK', license: 'MIT', source: 'https://github.com/colyseus/colyseus.js' },
  {
    name: 'Norigin Spatial Navigation',
    license: 'MIT',
    source: 'https://github.com/NoriginMedia/Norigin-Spatial-Navigation',
  },
  { name: 'Phaser', license: 'MIT', source: 'https://github.com/phaserjs/phaser' },
  { name: 'Three.js', license: 'MIT', source: 'https://github.com/mrdoob/three.js' },
  { name: 'Rapier', license: 'Apache-2.0', source: 'https://github.com/dimforge/rapier.js' },
  { name: 'FastNoise Lite', license: 'MIT', source: 'https://github.com/Auburn/FastNoiseLite' },
  { name: 'idb', license: 'ISC', source: 'https://github.com/jakearchibald/idb' },
  { name: 'meshoptimizer', license: 'MIT', source: 'https://github.com/zeux/meshoptimizer' },
  { name: 'ZzFX', license: 'MIT', source: 'https://github.com/KilledByAPixel/ZzFX' },
  { name: 'pixelfx', license: 'MIT', source: 'https://github.com/patch-gg/pixelfx' },
];
